import enums from '@/mixins/enums';
import persons from '@/mixins/persons';

export default {
  mixins: [enums, persons],
  computed: {
    getFunnelAffiliation() {
      let funnelAffiliation = 'web';
      const { DistributionChannelEnum } = this.enums;
      if (this.model.distributionChannel === DistributionChannelEnum.VIP) {
        if (this.model.broker.callcentrumBroker) {
          funnelAffiliation = 'callcentrum';
        } else {
          funnelAffiliation = 'vip';
        }
      }
      return funnelAffiliation;
    },
    getFunnelSubtype() {
      let funnelSubtype = '';
      if (this.insuredPersons[0].insuredPersonType) {
        funnelSubtype = this.insuredPersons[0].insuredPersonType.funnelSubtype;
        if (funnelSubtype === 'zmena') {
          funnelSubtype += `-${this.insuredPersons[0].previousInsuranceCompany.eventAction}`;
        } else {
          funnelSubtype += `-${this.insuredPersons[0].insuredPersonType.applicationType}`;
        }
      }
      return funnelSubtype;
    },
  },
  methods: {
    setFunnelSubType(insuredPersons) {
      const { InsuredPersonTypeEnum } = this.enums;

      this.$router.funnelSubtype = insuredPersons
        /*
        * Filters all persons who have selected insured person type and if is change application
        * then filter persons who have selected previous insurance company also.
        * */
        .filter((person) => {
          const { insuredPersonType } = person;
          if (!insuredPersonType) return false;
          if (insuredPersonType === InsuredPersonTypeEnum.CHANGE_OF_INSURANCE_COMPANY_ADULT
            || insuredPersonType === InsuredPersonTypeEnum.CHANGE_OF_INSURANCE_COMPANY_CHILD) {
            if (!person.previousInsuranceCompany) return false;
          }
          return true;
        })
        /*
        * Creates funnelSubType for each person
        * */
        .map((person) => {
          const { insuredPersonType, previousInsuranceCompany } = person;

          if (insuredPersonType === InsuredPersonTypeEnum.RETURN_FROM_ABROAD_ADULT
            || insuredPersonType === InsuredPersonTypeEnum.RETURN_FROM_ABROAD_CHILD) return 'navrat-zo-zahranicia';
          if (insuredPersonType === InsuredPersonTypeEnum.BIRTH_OF_CHILD) return 'narodenie-dietata';

          return `zmena-${previousInsuranceCompany.name$.toLowerCase()}`;
        })
        /*
        * Creates string of unique funnel sub types
        * */
        .reduce((acc, funnelSubType) => {
          if (acc.split('|').some((s) => s === funnelSubType)) return acc;

          if (!acc) {
            acc += funnelSubType;
            return acc;
          }

          return [...acc.split('|'), funnelSubType].join('|');
        }, '');
    },
    funnelCompleted() {
      this.$gtm.dataLayer().push({
        event: 'funnel_completed',
        funnel_type: 'uzp',
        funnel_subtype: this.getFunnelSubtype,
        funnel_affiliation: this.getFunnelAffiliation,
        agent_id: this.model.broker.number,
      });
    },
    esignFunnelCompleted() {
      this.$gtm.dataLayer().push({
        event: 'funnel_completed',
        funnel_type: 'uzp',
      });
    },
    funnelSaved() {
      this.$gtm.dataLayer().push({
        event: 'funnel_saved',
        funnel_type: 'uzp',
        funnel_subtype: this.getFunnelSubtype,
        funnel_affiliation: this.getFunnelAffiliation,
        agent_id: this.model.broker.number,
      });
    },
    funnelError(errorType, errorMessage, errorDetail) {
      this.$gtm.dataLayer().push({
        event: 'funnel_error',
        funnel_type: 'uzp',
        funnel_subtype: this.getFunnelSubtype,
        funnel_affiliation: this.getFunnelAffiliation,
        agent_id: this.model.broker.number,
        error_type: errorType,
        error_message: errorMessage,
        error_detail: errorDetail,
      });
    },
    esignFunnelError(errorType, errorMessage, errorDetail) {
      this.$gtm.dataLayer().push({
        event: 'funnel_error',
        funnel_type: 'uzp',
        error_type: errorType,
        error_message: errorMessage,
        error_detail: errorDetail,
      });
    },
    funnelLead(leadId) {
      this.$gtm.dataLayer().push({
        event: 'funnel_lead',
        funnel_type: 'uzp',
        funnel_subtype: this.getFunnelSubtype,
        funnel_affiliation: this.getFunnelAffiliation,
        agent_id: this.model.broker.number,
        lead_id: leadId,
      });
    },
    funnelInteraction() {
      this.$gtm.dataLayer().push({
        event: 'funnel_interaction',
        funnel_type: 'uzp',
        funnel_subtype: this.getFunnelSubtype,
        funnel_affiliation: this.getFunnelAffiliation,
        agent_id: this.model.broker.number,
        funnel_step_number: '',
        funnel_step_desc: '',
        funnel_question: 'podpis prihlášky',
        funnel_answer: this.model.delivery.deliveryType.funnelAnswer,
      });
    },
    funnelStep(description) {
      this.$gtm.dataLayer().push({
        event: 'funnel_step',
        funnel_type: 'uzp',
        funnel_subtype: this.getFunnelSubtype,
        funnel_affiliation: this.getFunnelAffiliation,
        agent_id: this.model.broker.number,
        funnel_step_number: this.model.step,
        funnel_step_desc: description,
      });
    },
  },
};
